import { useContext } from 'react';
import { WorkspaceConfigContext } from '@r/context/workspace-config-context.ts';

/**
 * Hook to check if product reference feature is enabled for the current workspace
 * @returns boolean indicating if product reference is enabled
 */
export const useProductReferenceEnabled = () => {
  const workspaceConfig = useContext(WorkspaceConfigContext);

  return workspaceConfig?.groupedConfigs?.core?.['is-reference-enabled'] === 'true';
};
